/// <reference path="../../ConfirmAlert.ts" />
/// <reference path="BaseField.ts" />

namespace MACRAIL.Forms.Fields {

export class ConfirmAlert extends BaseField {

    protected opts: ConfirmAlertOptions;

    private alert: MACRAIL.ConfirmAlert;

    constructor (element: string | JQuery, opts: ConfirmAlertOptions) {

        opts.defaultValue = opts.defaultValue || 0;

        super(element, opts);

        this.alert = opts.alert;

        this.element.on('confirmalert-statechange', () => {
            this.element.trigger('fieldchanged');
        });

        this.element.find('.btn').on('click', () => {
            this.setDirty(true);
        });
    }

    public getValue() {
        return this.alert.getState();
    }

}

interface ConfirmAlertOptions extends FieldOptions {
    alert: MACRAIL.ConfirmAlert;
}

}
